export default "__VITE_ASSET__DYXbFKFM__"